import React from 'react';
import { ArrowUpRightIcon, AwardIcon, MapPinIcon, MedalIcon } from 'lucide-react';
import { trustItems } from '../../data/site';
const proofIcons = {
  roots: MapPinIcon,
  experience: AwardIcon,
  achievement: MedalIcon
};
export function TrustStrip() {
  return <section aria-label="School experience and achievements" className="on-dark border-y border-white/10 bg-ink text-white" data-id="element-339" data-mp="3c66ati5nl300">
      <div className="mx-auto w-full max-w-[1600px] px-5 sm:px-8" data-id="element-340" data-mp="crkqnfua2iae">
        <ul className="bates-trust-grid grid divide-y divide-white/15 lg:grid-cols-3 lg:divide-x lg:divide-y-0" data-id="element-341" data-mp="csvuffnq3q1i">
          {trustItems.map(item => {
          const Icon = proofIcons[item.key];
          return <li key={item.key} className="py-5 lg:px-5 lg:py-4 lg:first:pl-0 lg:last:pr-0" data-id="element-342" data-mp="3v5k9uei8p3xd">
                <div className="flex items-center gap-2.5 text-[11px] font-semibold uppercase tracking-[0.14em] text-white/60" data-id="element-343" data-mp="wes9pqyd8but">
                  <Icon className="h-5 w-5 shrink-0 text-[#FF6268]" strokeWidth={1.6} aria-hidden="true" data-id="element-344" data-mp="rnag5nyo9djv" />
                  {item.label}
                </div>
                <h2 className="bates-trust-title mt-2 font-display text-[1.65rem] font-semibold uppercase leading-tight tracking-wide" data-id="element-345" data-mp="3ch1em13chhl4">
                  {item.title}
                </h2>
                <p className="bates-trust-description mt-1.5 max-w-[34rem] text-sm leading-relaxed text-white/80" data-id="element-346" data-mp="2yntn09f9km3f">{item.description}</p>
                <div className="mt-2 flex flex-wrap gap-x-5 gap-y-2" data-id="element-347" data-mp="2or74hraeu74k">
                  {item.sources.map(source => <a key={source.url} href={source.url} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[28px] items-center gap-1 text-xs font-medium text-white/65 underline decoration-white/25 underline-offset-4 transition-colors hover:text-white" data-id="element-348" data-mp="2trcp4ni9itd5">
                      {source.label}
                      <ArrowUpRightIcon className="h-3 w-3" aria-hidden="true" data-id="element-349" data-mp="dxksyngaoq0e" />
                      <span className="sr-only" data-id="element-350" data-mp="i07nwx89ir1t"> (opens in a new tab)</span>
                    </a>)}
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}